﻿import { Controller } from "@hotwired/stimulus";
import { qrcanvas } from "qrcanvas";

export default class extends Controller {
    static get values() {
        return {
            otpSecret: String
        };
    }

    static get targets() {
        return [
            "smsAuthenticationMethodForm",
            "appAuthenticationMethodForm",
            "qrCode",
            "setUpAgain"
        ];
    }

    displaySelectedAuthenticationMethodForm({ target }) {
        if (this.hasSmsAuthenticationMethodFormTarget) {
            this.smsAuthenticationMethodFormTarget.classList.toggle("d-none", target.value !== "SMS");
        }

        this.appAuthenticationMethodFormTarget.classList.toggle("d-none", target.value !== "App");
    }

    displaySetUpAgain(e) {
        e.preventDefault();
        this.setUpAgainTarget.classList.remove("d-none");
        e.target.remove();
    }

    qrCodeTargetConnected() {
        this.qrCodeTarget.appendChild(qrcanvas({
            data: `otpauth://totp/?secret=${this.otpSecretValue}`,
            size: 200
        }));
    }
}